













import { Component, Prop, Vue } from "vue-property-decorator";
import { FIRE } from "../../settings/CONST_REFS";
import { pushNotifcation } from "../../services/notification";
import { sessionsTracker } from "../../services/FirebaseQueries";

@Component
export default class SignOut extends Vue {

  // Data props
  private loggedIn = false;

  public signOut() {
    const username = FIRE.auth().currentUser?.displayName;
    
    const notification: any = {
      title: `Back soon ${
        FIRE.auth().currentUser?.displayName ? username : "Test"
      } 😥`,
      body: "Have a good night 😎",
      icon:
        "https://www.pinclipart.com/picdir/big/548-5485193_iphone-7-push-technology-apple-push-notification-push.png",
    };
 
    const user: any = JSON.parse(Object(localStorage.getItem('user')));
    const isMs = user.jobTitle ? true : false;
    localStorage.removeItem("user");
    FIRE.auth()
      .signOut()
      .then(() => {
        sessionsTracker(user, true, isMs)
        pushNotifcation(notification);
        this.$router.replace({ name: "Login" });
      });
  }
}
